import * as serviceContext from '../services/serviceContext';
import { REPORTS_ROOT as ReportsURL } from '../configs/api';

var options = {};
var headers = new Headers();

headers.append('Content-Type', 'application/json');
options.headers = headers;

export async function postProfitLoss(data) {
    
    try {
        const response = await serviceContext.post(`${ReportsURL}pnl/user`, JSON.stringify(data), options); //+"pnl", JSON.stringify(data), options);
        if(response.hasError === true){
            return false;
        }
        else{
            const res = response.json();
            return res;
        }
    }
    catch (error) {
        return error;
    }
};

// export async function postProfitLossCsv(data) {
    
//     try {
//         const response = await serviceContext.post(ReportsURL+"pnl/csv", JSON.stringify(data), options);
//         if(response.hasError === true){
//             return false;
//         }
//         else{
//             const res = response.json();
//             return res;
//         }
//     }
//     catch (error) {
//         return error;
//     }
// };

// export async function postMarketBets(data) {
    
//     try {
//         const response = await serviceContext.post(ReportsURL+"marketbets", JSON.stringify(data), options);
//         if(response.hasError === true){
//             return false;
//         }
//         else{
//             const res = response.json();
//             return res;
//         }
//     }
//     catch (error) {
//         return error;
//     }
// };
